export default "__VITE_ASSET__C$kSM4Nf__"